import React, { useState } from "react";
import "./Expert_Login_Details.css";
import Common_Vendor_Login_Details from "../../../common_components/common-login-vendor-details/Common_Login_Vendor_Details";
import Common_Login_Expert_Details from "../../../common_components/common-login-expert-details/Common_Expert_Login_Details";
import Banner_2 from "../../../contact-us/banner_2/Banner_2";

const Data = [
  {
    id: 1,
    name: "Shubham Mane",
    mobile_no: "**************",
    profession: "plumber",
    description: "Need Plumber On Urgent Basis",
    work_start: "within week",
    timeline: "3-4 days",
    state: "Maharashtra",
    district: "Haveli",
    taluka: "Pune",
    area: "bavdhan",
  },
  {
    id: 2,
    name: "Shubham Mane",
    mobile_no: "**************",
    profession: "plumber",
    description: "Need Plumber On Urgent Basis",
    work_start: "within week",
    timeline: "3-4 days",
    state: "Maharashtra",
    district: "Haveli",
    taluka: "Pune",
    area: "bavdhan",
  },
  {
    id: 2,
    name: "Shubham Mane",
    mobile_no: "**************",
    profession: "plumber",
    description: "Need Plumber On Urgent Basis",
    work_start: "within week",
    timeline: "3-4 days",
    state: "Maharashtra",
    district: "Haveli",
    taluka: "Pune",
    area: "bavdhan",
  },
  {
    id: 1,
    name: "Shubham Mane",
    mobile_no: "**************",
    profession: "plumber",
    description: "Need Plumber On Urgent Basis",
    work_start: "within week",
    timeline: "3-4 days",
    state: "Maharashtra",
    district: "Haveli",
    taluka: "Pune",
    area: "bavdhan",
  },
  {
    id: 2,
    name: "Shubham Mane",
    mobile_no: "**************",
    profession: "plumber",
    description: "Need Plumber On Urgent Basis",
    work_start: "within week",
    timeline: "3-4 days",
    state: "Maharashtra",
    district: "Haveli",
    taluka: "Pune",
    area: "bavdhan",
  },
  {
    id: 2,
    name: "Shubham Mane",
    mobile_no: "**************",
    profession: "plumber",
    description: "Need Plumber On Urgent Basis",
    work_start: "within week",
    timeline: "3-4 days",
    state: "Maharashtra",
    district: "Haveli",
    taluka: "Pune",
    area: "bavdhan",
  },
  {
    id: 1,
    name: "Shubham Mane",
    mobile_no: "**************",
    profession: "plumber",
    description: "Need Plumber On Urgent Basis",
    work_start: "within week",
    timeline: "3-4 days",
    state: "Maharashtra",
    district: "Haveli",
    taluka: "Pune",
    area: "bavdhan",
  },
  {
    id: 2,
    name: "Shubham Mane",
    mobile_no: "**************",
    profession: "plumber",
    description: "Need Plumber On Urgent Basis",
    work_start: "within week",
    timeline: "3-4 days",
    state: "Maharashtra",
    district: "Haveli",
    taluka: "Pune",
    area: "bavdhan",
  },
  {
    id: 2,
    name: "Shubham Mane",
    mobile_no: "**************",
    profession: "plumber",
    description: "Need Plumber On Urgent Basis",
    work_start: "within week",
    timeline: "3-4 days",
    state: "Maharashtra",
    district: "Haveli",
    taluka: "Pune",
    area: "bavdhan",
  },
];

const Expert_Login_Details = () => {
  const [showLoginHistory, setShowLoginHistory] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState(null);

  const handleCallClick = (vendorData) => {
    setSelectedVendor(vendorData);
    setShowLoginHistory(true);
  };

  const handleCloseModal = () => {
    setShowLoginHistory(false);
    setSelectedVendor(null);
  };

  return (
    <div className="Vendor-login-section">
      <div className="container mt-4 vendor-login-section">
        <div className="row">
          {Data.map((item, index) => (
            <div key={index} className="col-12 col-sm-6 col-md-6 col-lg-4 mb-4">
              <Common_Login_Expert_Details
                data={item}
                onCallClick={() => handleCallClick(item)}
              />
            </div>
          ))}
        </div>
      </div>

      <Banner_2 />
    </div>
  );
};

export default Expert_Login_Details;
